// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cabin-blocked-modal-wrapper {
  padding: 20px !important;
  width: 90%;
  max-width: 400px;
}
.cabin-blocked-modal-wrapper .cabin-blocked-modal-body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
}
.cabin-blocked-modal-wrapper .cabin-blocked-modal-body-wrapper h5 {
  margin: 0;
  text-align: center;
  font-weight: 700;
}
.cabin-blocked-modal-wrapper .cabin-blocked-modal-body-wrapper span {
  font-size: 18px;
  color: #7a7a7a;
  font-weight: 400;
  text-align: center;
}
.cabin-blocked-modal-wrapper .cabin-blocked-modal-body-wrapper span a {
  color: #7a7a7a;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.cabin-blocked-modal-wrapper .cabin-blocked-modal-body-wrapper > a {
  white-space: nowrap;
  text-decoration: none;
  background-color: #93288E;
  font-size: 18px;
  padding: 10px 40px;
  border-radius: 4px;
  font-weight: 700;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/PublicModalWrapper/CabinBlockedModal/style.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,UAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AACR;AACQ;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;AACZ;AAEQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAAZ;AAEY;EACI,cAAA;EACA,0BAAA;EACA,0BAAA;AAAhB;AAIQ;EACI,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAFZ","sourcesContent":[".cabin-blocked-modal-wrapper {\n    padding: 20px !important;\n    width: 90%;\n    max-width: 400px;\n\n    .cabin-blocked-modal-body-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        align-items: center;\n        justify-content: center;\n\n        h5 {\n            margin: 0;\n            text-align: center;\n            font-weight: 700;\n        }\n\n        span {\n            font-size: 18px;\n            color: #7a7a7a;\n            font-weight: 400;\n            text-align: center;\n\n            a {\n                color: #7a7a7a;\n                text-decoration: underline;\n                text-underline-offset: 2px;\n            }\n        }\n\n        >a {\n            white-space: nowrap;\n            text-decoration: none;\n            background-color: #93288E;\n            font-size: 18px;\n            padding: 10px 40px;\n            border-radius: 4px;\n            font-weight: 700;\n            color: #fff;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
